module.exports = __webpack_public_path__ + "img/icon.dba1974f.svg";